import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pexios, validate, toast, getDirection } from '../../../utils/functions';
import SearchablePicker from '../../master/SearchablePicker';
import Plate from '../../expert/Plate';
import Maps from '../../master/Maps';
import Input from "../../master/Input";
import CarSelect from "../../master/CarSelect";
import { useTranslation } from 'react-i18next';
import Switch from '../../master/Switch';
import CarInfo from '../userInfo/CarInfo';
// import Modal from '../../master/Modal';
import HeaderIcon from '../../../assets/images/header-icon/driver-info.png'
import DatePicker from '../../master/DatePicker';
import GetLocation from '../../../pages/client/GetLocation';
import { history } from '../../../utils/variables';
import { setRouterData } from '../../../redux/actions';
import Modal from '../../master/Modal';
import Loading from '../../../assets/images/gifs/loading.gif'


export default function RegisterData({ changeStep }) {
    
    const { t, i18n } = useTranslation();
    
    const using = [t('Personal'), t('Taxi'), t('Online taxi'), t('Suburban taxi'), t('Personal passenger')];
    const types = [t('To issue an insurance policy'), t('Capital Increase'), t('Installation of additional non-fabric accessories with an invoice'), t('Installation of additional non-fabric accessories without invoice'), t('Visit to confirm the renovation')];
    
    const form = useRef(null);
    const dispatch = useDispatch()

    const {user ,accidentInfo,location} = useSelector(store => store);
    const [step ,setStep] = useState(1)
    

    const [register, setRegister] = useState({
        fname: user.type === 'register_manager' ? '' : user.fname,
        lname: user.type === 'register_manager' ? '' : user.lname,
        mobile: user.type === 'register_manager' ? '' : user.mobile,
        type: null,
        car_type_id: null,
        car_brand_id: null,
        car_model_id: null,
        chassis_number: '',
        plate_type: 'car',
        plate_iran: '',
        plate_left: '',
        plate_right: '',
        plate_center: null,
        using: null,
        agencyCode: '',
        insurance_company: 2,
        cabin_type_id:null
    });
    
    const [insuranceCompanies, setInsuranceCompanies] = useState([]);
    // const [location, setLocation] = useState({
    //     lat: 35.696747,
    //     lng: 51.378444,
    // });
    const [loader, setLoader] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
    const [check,setCheck] = useState(false)
    useEffect(()=>{
        setRegister(prevState => ({
            ...prevState,
            fname: check ? '' : user.fname,
            lname: check ? '' : user.lname,
            mobile: check ? '' : user.mobile,
        }));
    },[check])

    useEffect(() => {
        setRegister(prevState=>({...prevState,...accidentInfo.details}))
        pexios('api/v2/get_insurance')
            .then(res => {
                setInsuranceCompanies(res.data.data);
                setLoadingData(false)
            });
        // navigator.geolocation.getCurrentPosition(info => {
        //     setLocation({
        //         lat: info.coords.latitude,
        //         lng: info.coords.longitude,
        //     });
        // });
    }, []);

    function changeText(val, name) {
        setRegister(prevState => ({
            ...prevState,
            [name]: val,
        }));
    }
    function changeUser(e) {
        const { checked } = e.target;
        setRegister(prevState => ({
            ...prevState,
            fname: checked ? '' : user.fname,
            lname: checked ? '' : user.lname,
            mobile: checked ? '' : user.mobile,
        }));
    }

    // function changeLocation(e) {
    //     setLocation({
    //         lat: e.lat,
    //         lng: e.lng,
    //     });
    // }
    function submit(){
        const err = validate(form);
        if (err.length) {
            // toast(`فیلد های اجباری ${err} را پر کنید.`, 'error');
            toast(t('Complete required fields',{err:err}), 'error');
            return
        } 
        // else {
        //     setLoader(true);
        //     pexios('api/add_register', 'post', {register, lat: location.lat, lng: location.lng})
        //         .then(res => {
        //             setLoader(false);
        //             changeStep(2, { registerId: res.data, carTypeId: register.car_type_id });
        //         });
        // }
        // changeStep(2)
        setStep(3)
    }
    // function handleEditInfo(type,form) {
    //     const err = validate(form);
    //     if (err.length) {
    //         // toast(`فیلد های اجباری ${err} را پر کنید.`, 'error');
    //         toast(t('Complete required fields',{err:err}), 'error');
    //         return
    //     } 
    //     setStep(2)
    // }
    function submitRegister() {
        setLoader(true)
        pexios('api/add_register', 'post', {register, ...location})
            .then(res => {
                setLoader(false);
                // changeStep(2, { registerId: res.data, carTypeId: register.car_type_id });
                dispatch(setRouterData({type: 'register',id:res.data}));
                history.push("/register-capturing")
            })
            .catch((err)=>{
                toast('ثبت اطلاعات با خطا مواجه شده است لطفا دوباره اقدام نمایید','error')
            })
        }

    return (
        <>
        {step !== 3 &&
        <div className='content'>
            
            {/* <div className='text-box mt20'>
                <p className='text-justify'>{t('Complete register feilds')}</p>
            </div> */}
            {loader &&
            <Modal visible={loader}>
                <div className='loader-modal'>
                    <img src={Loading} alt="loader"/>
                </div>
            </Modal>
            }
            {
                step === 1 &&
                <>
                {loadingData ?
                <Modal visible={loadingData}>
                    <div className='loader-modal'>
                        <img src={Loading} alt="loader"/>
                    </div>
                </Modal>
                :
                <CarInfo 
                    data={register}
                    changeData={changeText}
                    handleEditInfo={()=>setStep(2)}
                />
                }
                </>
            }
            {
                step === 2 &&
                <>
                <div className='title-image'>
                    <img src={HeaderIcon} alt="icon"/>
                </div>
                <p className='guide-text mx10 mt10'>
                لطفا اطلاعات درخواستی زیر را جهت ثبت درخواست تکمیل نمایید.               
                </p>

                <div className={`row ${getDirection(i18n.language) ==='rightToLeft'?' text-right': ' text-left'}`} ref={form}>
                {/* {
                    user.type !== 'register_manager' &&
                    // <label className='checkbox-parent'>
                    //     <input type='checkbox' className='ml10' onChange={changeUser} />
                    //     {t('For someone else')}
                    // </label>
                    <div className='col-12 row align-items-center'>
                        <label className='pr10 pt10 pl10' style={{fontSize:'14px'}}>{t('For someone else')}؟</label>
                        <Switch
                            value={check}
                            onChange={(value) => setCheck(value)}
                        />
                    </div>
                } */}
                <Input
                    label={t('Insurer first name')}
                    value={register.fname}
                    required
                    onChange={value => changeText(value, 'fname')}
                    name='fname'
                />
                <Input
                    label={t('Insurer last name')}
                    value={register.lname}
                    required
                    onChange={value => changeText(value, 'lname')}
                    name='lname'
                />
                <Input
                    label='کد ملی بیمه گزار'
                    value={register.national_id}
                    maxLength={10}
                    mode='numeric'
                    name='nationalId'
                    onChange={value => changeText(value, 'national_id')}
                    required
                />
                <DatePicker
                    label='تاریخ تولد بیمه گزار'
                    isBirthDate
                    value={register.birth_date}
                    onChange={date => changeText(date, 'birth_date')}
                    required
                />
                <Input
                    label={t('Insurer phone number')}
                    value={register.mobile}
                    mode='numeric'
                    type='tel'
                    required
                    onChange={value => changeText(value, 'mobile')}
                    isLTR={getDirection(i18n.language) ==='leftToRight'}
                    maxLength={11}
                />
                {/* <SearchablePicker
                    label={t('Request type')}
                    value={register.type}
                    data={types}
                    rtl={getDirection(i18n.language) ==='rightToLeft'}
                    required
                    onSelect={ type => changeText(type,'type')}
                /> */}
                {/* <CarSelect
                    data={{
                        carType: register.car_type_id,
                        carBrand: register.car_brand_id,
                        carModel: register.car_model_id,
                    }}
                    required
                    onChange={ (value, name) => changeText(value, name)}
                /> */}
                {/* <SearchablePicker
                    label={t('Using')}
                    value={register.using}
                    data={using}
                    rtl={getDirection(i18n.language) ==='rightToLeft'}
                    required
                    onSelect={ using => changeText(using, 'using') }
                /> */}
                {/* <Input
                    label={t('Chassis number')}
                    value={register.chassis_number}
                    required
                    onChange={value => changeText(value, 'chassis_number')}
                /> */}
                {/* {
                    user.type === 'user' &&
                    <> */}
                        <Input
                            label={t('Agent code')}
                            value={register.agencyCode}
                            onChange={value => changeText(value, 'agencyCode')}
                        />
                        <SearchablePicker
                            label={t('Insurance company')}
                            value={register.insurance_company}
                            data={insuranceCompanies}
                            titleKey='title'
                            valueKey='id'
                            rtl={getDirection(i18n.language) ==='rightToLeft'}
                            required
                            onSelect={ company => changeText(company, 'insurance_company') }
                            hasIcon
                        />
                    {/* </>
                } */}
                {/* <Plate
                    type={register.plate_type}
                    plate={{
                        plate_iran: register.plate_iran,
                        plate_right: register.plate_right,
                        plate_center: register.plate_center,
                        plate_left: register.plate_left,
                    }}
                    required
                    change={changeText}
                /> */}
                </div>
                <div className='d-flex mt30'>
                    <button className={`btn btn-circle btn-block btn-orange btn-bold mx10`} onClick={()=>setStep(1)}>
                        مرحله قبل
                    </button>
                    <button 
                        className={`btn btn-circle btn-block btn-white-purple btn-bold mx10`} 
                        onClick={submit}
                        >مرحله بعد
                    </button>
                </div>
                </>
            }
            {/* <div className='mt20'>
                <Maps
                    loc={[
                        location.lat,
                        location.lng,
                    ]}
                    changeLocation={changeLocation}
                />
            </div> */}
            {/* <div className='d-flex justify-center mt20'>
                <button className='btn btn-white-purple btn-circle w-50' onClick={submit} disabled={loader}>
                    {
                        loader ?
                            <i className='fas fa-spinner fa-spin'/>
                            : t('Submit')
                    }
                </button>
            </div> */}
        </div>
        }
        {
            step === 3 &&
            <GetLocation submitRegister={submitRegister} changeStep={()=>setStep(2)}/>
        }
        </>
    )

}
